module.exports = __webpack_public_path__ + "img/BANNER-B2B-MARCAS.f7b84efe.png";